// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-bidding-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.bidding-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === CONTROL PANEL SPACING & OVERLAP === */
.bidding-control-panel {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

/* === BIDDING HUB GRID & SOFT COLORS === */
.bidding-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 1.5rem;
}

.bidding-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
}

.bidding-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 20px -3px rgba(0, 0, 0, 0.05);
    border-color: #bfdbfe;
}

.bcard-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.25rem;
}

.bcard-title-wrapper {
    display: flex;
    align-items: center;
    gap: 0.85rem;
}

.bcard-icon {
    height: 42px;
    width: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.bg-indigo-light {
    background: #e0e7ff;
}

.text-indigo {
    color: #4338ca;
}

.bg-blue-light {
    background: #eff6ff;
}

.text-blue {
    color: #2563eb;
}

.border-blue {
    border: 1px solid #bfdbfe;
}

.text-slate {
    color: #64748b;
}

.bcard-title-wrapper h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #1e293b;
    font-weight: 800;
}

.month-pill {
    padding: 0.35rem 0.8rem;
    border-radius: 99px;
    font-size: 0.85rem;
    font-weight: 700;
}

.bcard-stats {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
    background: #f8fafc;
    padding: 1rem;
    border-radius: 12px;
    border: 1px solid #f1f5f9;
}

.bstat {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
}

.bstat span {
    color: #64748b;
    font-size: 0.85rem;
    font-weight: 600;
}

.bstat strong {
    color: #1e293b;
    font-size: 1.2rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    gap: 0.3rem;
}

.bcard-footer {
    border-top: 1px solid #f1f5f9;
    padding-top: 1.25rem;
    margin-top: auto;
}

/* Upgraded button with soft colors */
.enter-room-btn {
    width: 100%;
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    color: #2563eb;
    font-size: 1.05rem;
    font-weight: 700;
    padding: 0.85rem 1.25rem;
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s;
}

.enter-room-btn:hover {
    background: #dbeafe;
    color: #1d4ed8;
}

.enter-room-btn svg {
    transition: transform 0.2s;
}

.bidding-card:hover .enter-room-btn svg {
    transform: translateX(4px);
}

.status-indicator {
    width: 100%;
    padding: 0.85rem;
    border-radius: 12px;
    font-size: 0.95rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
}

.admin-round-indicator {
    background: #fef3c7;
    color: #b45309;
    border: 1px solid #fde68a;
}

/* =========================================
   === CONTROL ROOM LAYOUT ===
   ========================================= */
.room-layout {
    display: grid;
    grid-template-columns: 400px 1fr;
    gap: 2rem;
    align-items: start;
}

.room-controls-panel {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.room-status-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.room-status-card h3 {
    margin: 0 0 1.5rem 0;
    color: #1e293b;
    font-size: 1.25rem;
}

.pool-highlight {
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    padding: 1.5rem;
    border-radius: 12px;
    text-align: center;
    margin-bottom: 1.5rem;
}

.pool-highlight span {
    color: #059669;
    font-weight: 600;
    font-size: 0.95rem;
}

.pool-highlight h2 {
    color: #15803d;
    margin: 0.25rem 0 0 0;
    font-size: 2rem;
    font-weight: 800;
}

.action-box {
    background: #f8fafc;
    border: 1px solid #cbd5e1;
    border-radius: 12px;
    padding: 1.5rem;
}

.action-box h4 {
    margin: 0 0 0.5rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.1rem;
    color: #1e293b;
}

.action-box p {
    margin: 0 0 1.5rem 0;
    color: #475569;
    font-size: 0.95rem;
    line-height: 1.5;
}

/* =========================================
   === SCHEDULED BANNER & TERMS UI ===
   ========================================= */

.scheduled-banner {
    background-color: white;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 1.25rem;
    margin-bottom: 1.5rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.scheduled-icon {
    background-color: #eff6ff;
    color: #3b82f6;
    padding: 0.85rem;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.scheduled-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.scheduled-header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.35rem;
}

.scheduled-label {
    margin: 0 !important;
    /* overrides .action-box p */
    color: #64748b !important;
    font-size: 0.85rem !important;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.terms-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.2rem 0.6rem;
    border-radius: 99px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
}

.badge-default {
    background: #dcfce7;
    color: #15803d;
    border: 1px solid #bbf7d0;
}

.badge-custom {
    background: #e0e7ff;
    color: #4338ca;
    border: 1px solid #c7d2fe;
}

.scheduled-date {
    margin: 0;
    color: #1e293b;
    font-size: 1.1rem;
    font-weight: 800;
}

.setup-hint {
    font-size: 0.85rem !important;
    color: #64748b !important;
    margin-bottom: 1.25rem !important;
}

.default-terms-info {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    background: #f1f5f9;
    padding: 0.85rem 1rem;
    border-radius: 8px;
    border-left: 4px solid #94a3b8;
    margin-bottom: 1.5rem;
    color: #475569;
    font-size: 0.9rem;
}

.default-terms-info span {
    display: flex;
    align-items: center;
}

.default-terms-info strong {
    color: #334155;
    margin-right: 0.4rem;
}


/* =========================================
   === LIVE BIDDING INDICATORS ===
   ========================================= */

.live-indicator {
    background: #fee2e2;
    color: #b91c1c;
    padding: 0.75rem;
    border-radius: 8px;
    font-weight: 800;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #fecaca;
}

.pulse-dot.bg-red {
    background: #dc2626;
    animation: pulseRed 1.5s infinite;
}

@keyframes pulseRed {
    0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);
    }

    70% {
        transform: scale(1);
        box-shadow: 0 0 0 6px rgba(220, 38, 38, 0);
    }

    100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
    }
}

.fin-summary-mini {
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1rem;
}

.fin-summary-mini div {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    color: #475569;
}

.fin-summary-mini div:last-child {
    margin-bottom: 0;
}

.fin-summary-mini strong {
    color: #1e293b;
}

.final-hint {
    font-size: 0.8rem;
    color: #94a3b8;
    text-align: center;
    margin-top: 0.75rem;
}

/* =========================================
   === TIE RESOLUTION RE-DESIGN ===
   ========================================= */
.tie-box {
    background: #fffbeb;
    border: 1px solid #fde68a;
}

.tie-box-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.tie-box-header h4 {
    margin: 0;
    font-size: 1.2rem;
    color: #b45309;
}

.text-amber {
    color: #d97706;
}

.tie-box p {
    color: #92400e;
    margin-bottom: 1.5rem;
}

.tie-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.tie-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 1rem;
    border-radius: 12px;
    border: 1px solid #fde68a;
    gap: 1rem;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.tie-row-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    min-width: 0;
    /* Prevents flex blowout */
}

.tie-row-info span {
    font-weight: 600;
    color: #1e293b;
    font-size: 1.05rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.tie-row button {
    flex-shrink: 0;
    /* Prevents button from shrinking */
}

/* =========================================
   === LIVE FEED ===
   ========================================= */
.room-feed-panel {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    height: 600px;
    display: flex;
    flex-direction: column;
}

.room-feed-panel h3 {
    margin: 0 0 1rem 0;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e2e8f0;
    color: #1e293b;
    display: flex;
    justify-content: space-between;
}

.bid-count {
    color: #94a3b8;
    font-size: 1rem;
}

.feed-container {
    flex: 1 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.feed-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
}

.feed-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: #f8fafc;
    border-radius: 10px;
    border: 1px solid #f1f5f9;
}

.highest-bid {
    background: #fffbeb;
    border-color: #fde68a;
}

.feed-user {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-weight: 600;
    color: #334155;
}

.feed-avatar {
    height: 32px;
    width: 32px;
    background: #e2e8f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.highest-bid .feed-avatar {
    background: #fef08a;
    color: #d97706;
}

.feed-amount {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.2rem;
    color: #1e293b;
}

.text-gold {
    color: #d97706;
}

/* =========================================
   === RESPONSIVE ===
   ========================================= */
@media (max-width: 900px) {
    .room-layout {
        grid-template-columns: 1fr;
    }

    .room-feed-panel {
        height: 400px;
    }
}

@media (max-width: 768px) {
    .bidding-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .bidding-control-panel {
        padding: 1rem;
    }

    .admin-search-input-wrapper {
        max-width: 100% !important;
    }
}

/* Fix for mobile overlapping elements */
@media (max-width: 480px) {
    .tie-row {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
    }

    .tie-row button {
        width: 100%;
    }

    .scheduled-header-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        margin-bottom: 0.5rem;
    }
}

/* =========================================
   === CUSTOM DIALOG MODALS ===
   ========================================= */

.admin-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
    animation: fadeInOverlay 0.2s ease-out;
}

@keyframes fadeInOverlay {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.admin-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2.5rem 2rem;
    max-width: 420px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    animation: scaleIn 0.2s ease-out;
}

@keyframes scaleIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.confirm-dialog-card {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.confirm-icon-wrapper {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.25rem;
}

.confirm-dialog-card h3 {
    margin: 0 0 0.75rem 0;
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 800;
}

.confirm-dialog-card p {
    margin: 0;
    color: #64748b;
    line-height: 1.5;
    font-size: 1.05rem;
}

.modal-actions {
    display: flex;
    gap: 1rem;
}

.modal-actions button {
    flex: 1 1;
}

/* Modal Button Color Overrides */
.btn-primary-fill {
    background: #2563eb !important;
    color: white !important;
}

.btn-primary-fill:hover:not(:disabled) {
    background: #1d4ed8 !important;
}

.btn-danger-fill {
    background: #ef4444 !important;
    color: white !important;
}

.btn-danger-fill:hover:not(:disabled) {
    background: #dc2626 !important;
}

.btn-success-fill {
    background: #10b981 !important;
    color: white !important;
}

.btn-success-fill:hover:not(:disabled) {
    background: #059669 !important;
}

.bg-emerald-light {
    background: #ecfdf5;
}

.text-emerald {
    color: #059669;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Bidding.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,4DAA4D;IAC5D,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;8CAE8C;AAC9C;IACI,aAAa;IACb,gCAAgC;IAChC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;8CAE8C;;AAE9C;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,yBAAyB;IACzB,6BAA6B;IAC7B,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;;AAGA;;8CAE8C;;AAE9C;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI;QACI,sBAAsB;QACtB,0CAA0C;IAC9C;;IAEA;QACI,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,sBAAsB;QACtB,wCAAwC;IAC5C;AACJ;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;8CAE8C;AAC9C;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mCAAmC;AACvC;;AAEA;;8CAE8C;AAC9C;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,8CAA8C;IAC9C,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,cAAc;IACd,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;8CAE8C;AAC9C;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,WAAW;QACX,qBAAqB;IACzB;AACJ;;AAEA;;8CAE8C;;AAE9C;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,gCAAgC;AACpC;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA,iCAAiC;AACjC;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".admin-bidding-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.bidding-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1200px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === CONTROL PANEL SPACING & OVERLAP === */\n.bidding-control-panel {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n/* === BIDDING HUB GRID & SOFT COLORS === */\n.bidding-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n    gap: 1.5rem;\n}\n\n.bidding-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n}\n\n.bidding-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 12px 20px -3px rgba(0, 0, 0, 0.05);\n    border-color: #bfdbfe;\n}\n\n.bcard-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 1.25rem;\n}\n\n.bcard-title-wrapper {\n    display: flex;\n    align-items: center;\n    gap: 0.85rem;\n}\n\n.bcard-icon {\n    height: 42px;\n    width: 42px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.bg-indigo-light {\n    background: #e0e7ff;\n}\n\n.text-indigo {\n    color: #4338ca;\n}\n\n.bg-blue-light {\n    background: #eff6ff;\n}\n\n.text-blue {\n    color: #2563eb;\n}\n\n.border-blue {\n    border: 1px solid #bfdbfe;\n}\n\n.text-slate {\n    color: #64748b;\n}\n\n.bcard-title-wrapper h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.month-pill {\n    padding: 0.35rem 0.8rem;\n    border-radius: 99px;\n    font-size: 0.85rem;\n    font-weight: 700;\n}\n\n.bcard-stats {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    background: #f8fafc;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1px solid #f1f5f9;\n}\n\n.bstat {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n}\n\n.bstat span {\n    color: #64748b;\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.bstat strong {\n    color: #1e293b;\n    font-size: 1.2rem;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    gap: 0.3rem;\n}\n\n.bcard-footer {\n    border-top: 1px solid #f1f5f9;\n    padding-top: 1.25rem;\n    margin-top: auto;\n}\n\n/* Upgraded button with soft colors */\n.enter-room-btn {\n    width: 100%;\n    background: #eff6ff;\n    border: 1px solid #bfdbfe;\n    color: #2563eb;\n    font-size: 1.05rem;\n    font-weight: 700;\n    padding: 0.85rem 1.25rem;\n    border-radius: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.enter-room-btn:hover {\n    background: #dbeafe;\n    color: #1d4ed8;\n}\n\n.enter-room-btn svg {\n    transition: transform 0.2s;\n}\n\n.bidding-card:hover .enter-room-btn svg {\n    transform: translateX(4px);\n}\n\n.status-indicator {\n    width: 100%;\n    padding: 0.85rem;\n    border-radius: 12px;\n    font-size: 0.95rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n}\n\n.admin-round-indicator {\n    background: #fef3c7;\n    color: #b45309;\n    border: 1px solid #fde68a;\n}\n\n/* =========================================\n   === CONTROL ROOM LAYOUT ===\n   ========================================= */\n.room-layout {\n    display: grid;\n    grid-template-columns: 400px 1fr;\n    gap: 2rem;\n    align-items: start;\n}\n\n.room-controls-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.room-status-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.room-status-card h3 {\n    margin: 0 0 1.5rem 0;\n    color: #1e293b;\n    font-size: 1.25rem;\n}\n\n.pool-highlight {\n    background: #f0fdf4;\n    border: 1px solid #bbf7d0;\n    padding: 1.5rem;\n    border-radius: 12px;\n    text-align: center;\n    margin-bottom: 1.5rem;\n}\n\n.pool-highlight span {\n    color: #059669;\n    font-weight: 600;\n    font-size: 0.95rem;\n}\n\n.pool-highlight h2 {\n    color: #15803d;\n    margin: 0.25rem 0 0 0;\n    font-size: 2rem;\n    font-weight: 800;\n}\n\n.action-box {\n    background: #f8fafc;\n    border: 1px solid #cbd5e1;\n    border-radius: 12px;\n    padding: 1.5rem;\n}\n\n.action-box h4 {\n    margin: 0 0 0.5rem 0;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 1.1rem;\n    color: #1e293b;\n}\n\n.action-box p {\n    margin: 0 0 1.5rem 0;\n    color: #475569;\n    font-size: 0.95rem;\n    line-height: 1.5;\n}\n\n/* =========================================\n   === SCHEDULED BANNER & TERMS UI ===\n   ========================================= */\n\n.scheduled-banner {\n    background-color: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 1.25rem;\n    margin-bottom: 1.5rem;\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.scheduled-icon {\n    background-color: #eff6ff;\n    color: #3b82f6;\n    padding: 0.85rem;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.scheduled-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.scheduled-header-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.35rem;\n}\n\n.scheduled-label {\n    margin: 0 !important;\n    /* overrides .action-box p */\n    color: #64748b !important;\n    font-size: 0.85rem !important;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.terms-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    padding: 0.2rem 0.6rem;\n    border-radius: 99px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n}\n\n.badge-default {\n    background: #dcfce7;\n    color: #15803d;\n    border: 1px solid #bbf7d0;\n}\n\n.badge-custom {\n    background: #e0e7ff;\n    color: #4338ca;\n    border: 1px solid #c7d2fe;\n}\n\n.scheduled-date {\n    margin: 0;\n    color: #1e293b;\n    font-size: 1.1rem;\n    font-weight: 800;\n}\n\n.setup-hint {\n    font-size: 0.85rem !important;\n    color: #64748b !important;\n    margin-bottom: 1.25rem !important;\n}\n\n.default-terms-info {\n    display: flex;\n    align-items: center;\n    gap: 0.6rem;\n    background: #f1f5f9;\n    padding: 0.85rem 1rem;\n    border-radius: 8px;\n    border-left: 4px solid #94a3b8;\n    margin-bottom: 1.5rem;\n    color: #475569;\n    font-size: 0.9rem;\n}\n\n.default-terms-info span {\n    display: flex;\n    align-items: center;\n}\n\n.default-terms-info strong {\n    color: #334155;\n    margin-right: 0.4rem;\n}\n\n\n/* =========================================\n   === LIVE BIDDING INDICATORS ===\n   ========================================= */\n\n.live-indicator {\n    background: #fee2e2;\n    color: #b91c1c;\n    padding: 0.75rem;\n    border-radius: 8px;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n    border: 1px solid #fecaca;\n}\n\n.pulse-dot.bg-red {\n    background: #dc2626;\n    animation: pulseRed 1.5s infinite;\n}\n\n@keyframes pulseRed {\n    0% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);\n    }\n\n    70% {\n        transform: scale(1);\n        box-shadow: 0 0 0 6px rgba(220, 38, 38, 0);\n    }\n\n    100% {\n        transform: scale(0.95);\n        box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);\n    }\n}\n\n.fin-summary-mini {\n    background: white;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 1rem;\n    margin-bottom: 1rem;\n}\n\n.fin-summary-mini div {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n    color: #475569;\n}\n\n.fin-summary-mini div:last-child {\n    margin-bottom: 0;\n}\n\n.fin-summary-mini strong {\n    color: #1e293b;\n}\n\n.final-hint {\n    font-size: 0.8rem;\n    color: #94a3b8;\n    text-align: center;\n    margin-top: 0.75rem;\n}\n\n/* =========================================\n   === TIE RESOLUTION RE-DESIGN ===\n   ========================================= */\n.tie-box {\n    background: #fffbeb;\n    border: 1px solid #fde68a;\n}\n\n.tie-box-header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n\n.tie-box-header h4 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #b45309;\n}\n\n.text-amber {\n    color: #d97706;\n}\n\n.tie-box p {\n    color: #92400e;\n    margin-bottom: 1.5rem;\n}\n\n.tie-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.tie-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: white;\n    padding: 1rem;\n    border-radius: 12px;\n    border: 1px solid #fde68a;\n    gap: 1rem;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.tie-row-info {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    min-width: 0;\n    /* Prevents flex blowout */\n}\n\n.tie-row-info span {\n    font-weight: 600;\n    color: #1e293b;\n    font-size: 1.05rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.tie-row button {\n    flex-shrink: 0;\n    /* Prevents button from shrinking */\n}\n\n/* =========================================\n   === LIVE FEED ===\n   ========================================= */\n.room-feed-panel {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    height: 600px;\n    display: flex;\n    flex-direction: column;\n}\n\n.room-feed-panel h3 {\n    margin: 0 0 1rem 0;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #e2e8f0;\n    color: #1e293b;\n    display: flex;\n    justify-content: space-between;\n}\n\n.bid-count {\n    color: #94a3b8;\n    font-size: 1rem;\n}\n\n.feed-container {\n    flex: 1;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.feed-empty {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #94a3b8;\n}\n\n.feed-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem;\n    background: #f8fafc;\n    border-radius: 10px;\n    border: 1px solid #f1f5f9;\n}\n\n.highest-bid {\n    background: #fffbeb;\n    border-color: #fde68a;\n}\n\n.feed-user {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    font-weight: 600;\n    color: #334155;\n}\n\n.feed-avatar {\n    height: 32px;\n    width: 32px;\n    background: #e2e8f0;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n}\n\n.highest-bid .feed-avatar {\n    background: #fef08a;\n    color: #d97706;\n}\n\n.feed-amount {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 1.2rem;\n    color: #1e293b;\n}\n\n.text-gold {\n    color: #d97706;\n}\n\n/* =========================================\n   === RESPONSIVE ===\n   ========================================= */\n@media (max-width: 900px) {\n    .room-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .room-feed-panel {\n        height: 400px;\n    }\n}\n\n@media (max-width: 768px) {\n    .bidding-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .bidding-control-panel {\n        padding: 1rem;\n    }\n\n    .admin-search-input-wrapper {\n        max-width: 100% !important;\n    }\n}\n\n/* Fix for mobile overlapping elements */\n@media (max-width: 480px) {\n    .tie-row {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1rem;\n    }\n\n    .tie-row button {\n        width: 100%;\n    }\n\n    .scheduled-header-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.5rem;\n        margin-bottom: 0.5rem;\n    }\n}\n\n/* =========================================\n   === CUSTOM DIALOG MODALS ===\n   ========================================= */\n\n.admin-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n    animation: fadeInOverlay 0.2s ease-out;\n}\n\n@keyframes fadeInOverlay {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.admin-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2.5rem 2rem;\n    max-width: 420px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    animation: scaleIn 0.2s ease-out;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.confirm-dialog-card {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.confirm-icon-wrapper {\n    width: 72px;\n    height: 72px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.25rem;\n}\n\n.confirm-dialog-card h3 {\n    margin: 0 0 0.75rem 0;\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n.confirm-dialog-card p {\n    margin: 0;\n    color: #64748b;\n    line-height: 1.5;\n    font-size: 1.05rem;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 1rem;\n}\n\n.modal-actions button {\n    flex: 1;\n}\n\n/* Modal Button Color Overrides */\n.btn-primary-fill {\n    background: #2563eb !important;\n    color: white !important;\n}\n\n.btn-primary-fill:hover:not(:disabled) {\n    background: #1d4ed8 !important;\n}\n\n.btn-danger-fill {\n    background: #ef4444 !important;\n    color: white !important;\n}\n\n.btn-danger-fill:hover:not(:disabled) {\n    background: #dc2626 !important;\n}\n\n.btn-success-fill {\n    background: #10b981 !important;\n    color: white !important;\n}\n\n.btn-success-fill:hover:not(:disabled) {\n    background: #059669 !important;\n}\n\n.bg-emerald-light {\n    background: #ecfdf5;\n}\n\n.text-emerald {\n    color: #059669;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
